var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9842 5.75955V24H8.95752V5.75955H0.641602V0H23.3339V5.75955H14.9814H14.9842Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6899 23.4186C32.2681 23.4186 34.3583 21.3285 34.3583 18.7502C34.3583 16.1719 32.2681 14.0818 29.6899 14.0818C27.1116 14.0818 25.0215 16.1719 25.0215 18.7502C25.0215 21.3285 27.1116 23.4186 29.6899 23.4186Z",
    fill: "#208CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTp);
export default __webpack_public_path__ + "static/media/logo_tp.f5e30e06418db13fbcea217643d2374b.svg";
export { ForwardRef as ReactComponent };